import { USER_REFRESH, DELETE_USER_SUCCESS, IMPORT_USER_SUCCESS } from '../actionTypes';

const initialState = { refresh: false, deleteSuccess: false, importSuccess: false };

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_REFRESH:
      return { ...state, refresh: action.payload };
    case DELETE_USER_SUCCESS:
      return { ...state, deleteSuccess: true };
    case IMPORT_USER_SUCCESS:
      return { ...state, importSuccess: true };
    default:
      return { ...state };
  }
};